import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';
import { disableAllMenu, expandImageUrl, isActiveExpandImageModal } from 'modules/actions/statusMenu';
import { reRenderChat } from 'modules/actions/chat';
import { Slide } from 'pure-react-carousel';
import CarouselSlider from 'components/atoms/TemplateCarouselSlider';
/**
 * ImageCarousel
 */
const ImageCarousel = ({ boxStyle, item, viewType }) => {
  const dispatch = useDispatch();
  const { items, type, id } = item;
  const ImageBox = useRef();
  const [imgState, setImgState] = useState(400);
  const slideBoxSet = boxStyle;
  const slideLength = items.length;
  const slideBoxSetStyle = {
    width: `${slideBoxSet.width}px`,
    height: `${imgState}px`,
    margin: `0 ${slideBoxSet.margin}px`,
  };
  const handleOnLoad = e => {
    setImgState(e.currentTarget.height);
    dispatch(reRenderChat());
  };

  const handleOnError = event => {
    event.currentTarget.src = 'images/noimage.png';
    event.currentTarget.className = 'errorImg';
    event.currentTarget.alt = '이미지 로드 실패';
  };

  const expandImage = url => {
    // event.currentTarget.src = 'images/noimage.png';
    // event.currentTarget.className = 'errorImg';
    // event.currentTarget.alt = '이미지 로드 실패';

    dispatch(disableAllMenu());
    dispatch(isActiveExpandImageModal(true));
    dispatch(expandImageUrl(url));
  };
  const constentSet = () => {
    return (
      <>
        {items.map((tempItem, idx) => {
          let htmlCheck = false;
          if (tempItem.image.image.includes('<img')) {
            htmlCheck = true;
          }
          // console.log(tempItem.image.image);
          return (
            <Slide key={`slide_${idx}`} index={idx} className="_carousel_default"  aria-roledescription="card" style={slideBoxSetStyle}>
                <div className="_cont_image">
                  <div key={`${id}_${idx}`} className="_box">
                    <div
                      className="_image_box"
                      onClick={() => {
                        expandImage(htmlCheck ? tempItem.image.image.replace('<img src="', '').replace('"></img>', '') : tempItem[type].image);
                      }}
                      ref={ImageBox}
                    >
                      {htmlCheck ? (
                        <img src={tempItem.image.image.replace('<img src="', '').replace('"></img>', '')} alt={tempItem[type].alt} onLoad={handleOnLoad} onError={handleOnError} />
                      ) : (
                        <img src={tempItem[type].image} alt={tempItem[type].alt} onLoad={handleOnLoad} onError={handleOnError}/>
                      )}
                    </div>
                  </div>
                </div>
            </Slide >
          );
        })}

      </>
    );
  };
  return (
    <>
      <div className="_carousel_button_div _image_carousel">
        <CarouselSlider slideBoxSet={slideBoxSet} contentCount={slideLength} contentSet={constentSet} />
      </div>
    </>
  );
};
ImageCarousel.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
};
ImageCarousel.defaultProps = {
  boxStyle: { width: 150, margin: 10, height: '220px' },
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
};

export default ImageCarousel;
